import React, { useState, useEffect } from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { openWhatsAppConsultation } from '../../utils/whatsapp';
import './WhatsAppFloating.css';

const WhatsAppFloating = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      // Hide when near footer
      const footer = document.querySelector('.footer');
      if (footer) {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        // Hide button when footer is visible (100px threshold)
        setIsVisible(footerTop > windowHeight - 100);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial state

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    openWhatsAppConsultation();
  };

  return (
    <button
      className={`whatsapp-floating ${isVisible ? 'visible' : 'hidden'}`}
      onClick={handleClick}
      aria-label="تواصل عبر واتساب"
      title="تواصل معنا عبر واتساب"
    >
      <FaWhatsapp className="whatsapp-icon" />
      <span className="whatsapp-text">تواصل معنا</span>
    </button>
  );
};

export default WhatsAppFloating;
